function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 7.58074,
  cy: 1.4529,
  rx: 1.47266,
  ry: 1.4529,
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 7.58074,
  cy: 7.26442,
  rx: 1.47266,
  ry: 1.4529,
  fill: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 7.58074,
  cy: 13.0761,
  rx: 1.47266,
  ry: 1.4529,
  fill: "black"
});

var _ref5 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 1.69019,
  cy: 7.26442,
  rx: 1.47266,
  ry: 1.4529,
  fill: "black"
});

var _ref6 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 1.69019,
  cy: 1.4529,
  rx: 1.47266,
  ry: 1.4529,
  fill: "black"
});

var _ref7 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 1.69019,
  cy: 13.0761,
  rx: 1.47266,
  ry: 1.4529,
  fill: "black"
});

function SvgDndLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 15,
    viewBox: "0 0 10 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDndLogo);
export default __webpack_public_path__ + "static/media/dnd-logo.19c90c93.svg";
export { ForwardRef as ReactComponent };